export default
`id: /soml/   # id for the schema, should start with '/soml/'
label:       # label for the schema
creator:     # creator for the schema
created:     # date the schema is created
updated:     # date the schema is updated
versionInfo: # version of the schema
config:
  # optional section with configurations used by the Platform

types:
  # optional section with configurations used by the Platform

prefixes:
  # define prefixes for this schema domain

specialPrefixes:
  # base IRI for data (resources)
  base_iri:
  # default namespace for vocabulary (ontology) terms
  vocab_iri:
  # prefix corresponding to the vocab IRI
  vocab_prefix:

properties:
  # define global property definitions

objects:
  # define objects and their properties

rbac:
  # define role based access control to objects and properties
  roles:
`
